export const mutationTypes = {
  getReport360Start: '[reports] get report 360 start',
  getReport360Success: '[reports] get report 360 success',
  getReport360Failure: '[reports] get report 360 failure',

  getReport360CompareStart: '[reports] get report 360 compare start',
  getReport360CompareSuccess: '[reports] get report 360 compare success',
  getReport360CompareFailure: '[reports] get report 360 compare failure',

  getReportPersonalStart: '[reports] get report personal start',
  getReportPersonalSuccess: '[reports] get report personal success',
  getReportPersonalFailure: '[reports] get report personal failure',

  getReportBHPersonalStart: '[reports] get report bh personal start',
  getReportBHPersonalSuccess: '[reports] get report bh personal success',
  getReportBHPersonalFailure: '[reports] get report bh personal failure',

  getReportBHPersonalTeamStart: '[reports] get report bh personal team start',
  getReportBHPersonalTeamSuccess: '[reports] get report bh personal team success',
  getReportBHPersonalTeamFailure: '[reports] get report bh personal team failure',

  getReportSelfStart: '[reports] get report self start',
  getReportSelfSuccess: '[reports] get report self success',
  getReportSelfFailure: '[reports] get report self failure',

  getReportSelfVersionsStart: '[reports] get report self versions start',
  getReportSelfVersionsSuccess: '[reports] get report self versions success',
  getReportSelfVersionsFailure: '[reports] get report self versions failure',

  getReportTeamStart: '[reports] get report team start',
  getReportTeamSuccess: '[reports] get report team success',
  getReportTeamFailure: '[reports] get report team failure',

  getReportTeamSpecsStart: '[reports] get report team specs start',
  getReportTeamSpecsSuccess: '[reports] get report team specs success',
  getReportTeamSpecsFailure: '[reports] get report team specs failure',

  getReportTeamPersonalStart: '[reports] get report team personal start',
  getReportTeamPersonalSuccess: '[reports] get report team personal success',
  getReportTeamPersonalFailure: '[reports] get report team personal failure',

  getReportTeamBHPersonalStart: '[reports] report team bh personal start',
  getReportTeamBHPersonalSuccess: '[reports] report team bh personal success',
  getReportTeamBHPersonalFailure: '[reports] report team bh personal failure',

  getReportParamsStart: '[reports] get report params start',
  getReportParamsSuccess: '[reports] get report params success',
  getReportParamsFailure: '[reports] get report params failure',

  setReportParamsStart: '[reports] set report params start',
  setReportParamsSuccess: '[reports] set report params success',
  setReportParamsFailure: '[reports] set report params failure',

  getReportLinkStart: '[reports] get report link start',
  getReportLinkSuccess: '[reports] get report link success',
  getReportLinkFailure: '[reports] get report link failure',

  uploadDiagramStart: '[reports] upload diagram start',
  uploadDiagramSuccess: '[reports] upload diagram success',
  uploadDiagramFailure: '[reports] upload diagram failure',

  generateReportToPDFStart: '[reports] generate report to pdf start',
  generateReportToPDFSuccess: '[reports] generate report to pdf success',
  generateReportToPDFFailure: '[reports] generate report to pdf failure',

  exportReportStart: '[reports] export report start',
  exportReportSuccess: '[reports] export report success',
  exportReportFailure: '[reports] export report failure',

  getCommentsParamsStart: '[reports] get comments params start',
  getCommentsParamsSuccess: '[reports] get comments params success',
  getCommentsParamsFailure: '[reports] get comments params failure',

  changeCommentsParamsStart: '[reports] change comments params start',
  changeCommentsParamsSuccess: '[reports] change comments params success',
  changeCommentsParamsFailure: '[reports] change comments params failure',
};

const mutations = {
  [mutationTypes.getReport360Start](state) {
    state.isLoading = true;
    state.errors = null;
    state.report360 = null;
    state.reportLink = null;
  },
  [mutationTypes.getReport360Success](state, payload) {
    state.isLoading = false;
    state.report360 = payload;
  },
  [mutationTypes.getReport360Failure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReport360CompareStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.report360Compare = null;
    state.reportLink = null;
  },
  [mutationTypes.getReport360CompareSuccess](state, payload) {
    state.isLoading = false;
    state.report360Compare = payload;
  },
  [mutationTypes.getReport360CompareFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportPersonalStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportPersonal = null;
    state.reportLink = null;
  },
  [mutationTypes.getReportPersonalSuccess](state, payload) {
    state.isLoading = false;
    state.reportPersonal = payload;
  },
  [mutationTypes.getReportPersonalFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportBHPersonalStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportBHPersonal = null;
    state.reportLink = null;
  },
  [mutationTypes.getReportBHPersonalSuccess](state, payload) {
    state.isLoading = false;
    state.reportBHPersonal = payload;
  },
  [mutationTypes.getReportBHPersonalFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportBHPersonalTeamStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportBHPersonalTeam = null;
    state.reportLink = null;
  },
  [mutationTypes.getReportBHPersonalTeamSuccess](state, payload) {
    state.isLoading = false;
    state.reportBHPersonalTeam = payload;
  },
  [mutationTypes.getReportBHPersonalTeamFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportSelfStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportSelf = null;
    state.reportLink = null;
  },
  [mutationTypes.getReportSelfSuccess](state, payload) {
    state.isLoading = false;
    state.reportSelf = payload;
  },
  [mutationTypes.getReportSelfFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportSelfVersionsStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportSelfVersions = null;
  },
  [mutationTypes.getReportSelfVersionsSuccess](state, payload) {
    state.isLoading = false;
    state.reportSelfVersions = payload;
  },
  [mutationTypes.getReportSelfVersionsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportTeamStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportTeam = null;
  },
  [mutationTypes.getReportTeamSuccess](state, payload) {
    state.isLoading = false;
    state.reportTeam = payload;
  },
  [mutationTypes.getReportTeamFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportTeamSpecsStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportTeamSpecs = null;
  },
  [mutationTypes.getReportTeamSpecsSuccess](state, payload) {
    state.isLoading = false;
    state.reportTeamSpecs = payload;
  },
  [mutationTypes.getReportTeamSpecsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportTeamPersonalStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.teamsPersonal = null;
  },
  [mutationTypes.getReportTeamPersonalSuccess](state, payload) {
    state.isLoading = false;
    state.teamsPersonal = payload;
  },
  [mutationTypes.getReportTeamPersonalFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportTeamBHPersonalStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.teamsBHPersonal = null;
  },
  [mutationTypes.getReportTeamBHPersonalSuccess](state, payload) {
    state.isLoading = false;
    state.teamsBHPersonal = payload;
  },
  [mutationTypes.getReportTeamBHPersonalFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getReportParamsStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportParams = null;
  },
  [mutationTypes.getReportParamsSuccess](state, payload) {
    state.isLoading = false;
    state.reportParams = payload;
  },
  [mutationTypes.getReportParamsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.setReportParamsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.setReportParamsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.setReportParamsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getReportLinkStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.reportLink = null;
  },
  [mutationTypes.getReportLinkSuccess](state, payload) {
    state.isLoading = false;
    state.reportLink = payload;
  },
  [mutationTypes.getReportLinkFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.uploadDiagramStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.uploadDiagramSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.uploadDiagramFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.generateReportToPDFStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.generateReportToPDFSuccess](state) {
    state.isLoading = false;
  },
  [mutationTypes.generateReportToPDFFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.exportReportStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.exportReportSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.exportReportFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getCommentsParamsStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.commentsParams = null;
  },
  [mutationTypes.getCommentsParamsSuccess](state, payload) {
    state.isLoading = false;
    state.commentsParams = payload;
  },
  [mutationTypes.getCommentsParamsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.changeCommentsParamsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.changeCommentsParamsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.changeCommentsParamsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },
};

export default mutations;
